import { Card, Typography } from '@mui/material';
import { format } from 'date-fns';
import { FC } from 'react';
import { Colors } from 'src/components/utils/Theme';
import { ForumItem } from 'src/models';

interface Props {
  item: ForumItem;
}

export const ForumPost: FC<Props> = ({ item }) => {
  const renderDate = (date: string) => {
    return format(new Date(date), 'dd MMM yyyy HH:mm');
  };
  return (
    <Card
      sx={{
        p: 2,
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h5">{item.userName}</Typography>
      <Typography variant="subtitle2">{renderDate(item.updatedAt)}</Typography>
      <Typography paddingTop={2} paddingBottom={2} fontSize={'18px'} fontWeight={500}>
        {item.text}
      </Typography>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          rowGap: '6px',
        }}
      >
        {item.attachments?.map((x, index) => (
          <div
            style={{
              backgroundColor: Colors.PRIMARY_COLOR,
              padding: '4px 8px',
              borderRadius: '4px',
              color: 'white',
              cursor: 'pointer',
            }}
            key={index}
            onClick={() => window.open(x.url, '_blank')}
          >
            {x.name}
          </div>
        ))}
      </div>
    </Card>
  );
};
